var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLifeAndPeopleElder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Basics",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Basics/Icons",
    transform: "translate(-2352.000000, -1710.000000)",
    fill: "#262626"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Life-and-people/Elder",
    transform: "translate(2352.000000, 1710.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9,10.2959812 L9.04218975,18.9999891 L10.462235,18.9999891 L10.462235,27.0789964 C10.462235,29.2439984 12.2681622,31 14.4970158,31 L15.7678535,31 L15.7678535,18.9999891 L17.2619881,12.3939831 L18.665569,15.9999864 L24,15.9999864 L24,12.9999837 L20.797695,12.9999837 L18.4710846,7.0459783 C17.5048364,6.34297766 16.3770323,5.81997719 15.12163,5.55197694 L15.0588598,5.53897693 C11.9913562,4.90597636 9.11319201,7.25097848 9,10.2959812 L9,10.2959812 Z M21.9419634,31 L24,31 L24,16.9999873 L21.9419634,16.9999873 L21.9419634,31 Z M19.9209714,1.05897287 C21.3091171,1.35497314 22.1858407,2.68897435 21.8822803,4.03697557 C21.5766619,5.38597679 20.2039514,6.23897757 18.8168347,5.9429773 C17.428689,5.64697703 16.5509364,4.31297582 16.8565548,2.9639746 C17.1611443,1.61597338 18.5338547,0.761972603 19.9209714,1.05897287 L19.9209714,1.05897287 Z",
    id: 34
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLifeAndPeopleElder);
export default __webpack_public_path__ + "static/media/life-and-people-elder.48837b26.svg";
export { ForwardRef as ReactComponent };